export default __webpack_public_path__ + "static/media/Mask.f0ec1ae2.jpg";